import { SeIcon, SeTabbar } from "@se/web-ui-react";

const DynamicTabbar = ({
  items,
  activeIndex,
  editingIndex,
  newItemValue,
  handleItemClick,
  handleDoubleClick,
  handleInputChange,
  handleInputBlur,
  removeItem,
  addItem,
  itemName,
  itemId,
  tabName,
  showAddRemove = true,
  componentType = ""
}) => {
  let clickTimer = null;

  function handleTabClickWrapper(index, item) {
    if (clickTimer) {
      clearTimeout(clickTimer);
      clickTimer = null;
      return; // Double-click will handle
    }
    clickTimer = setTimeout(() => {
      handleItemClick(index);
      clickTimer = null;
    }, 200);
  }

  function handleTabDoubleClickWrapper(index, item) {
    if (clickTimer) {
      clearTimeout(clickTimer);
      clickTimer = null;
    }
    handleDoubleClick(index, item);
  }

  function handleTabKeyDownWrapper(event, index, item) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleTabClickWrapper(index, item);
    }
  }
  return (
    <SeTabbar color="alternative" style={{pointerEvents:"auto !important"}}>
      <nav style={{pointerEvents:"auto !important"}}>
        {items?.length &&
          items?.map((item, index) => (
            <a
              key={item?.[itemId]}
              className={activeIndex === index ? "active" : ""}
              role="button"
              tabIndex={0}
              // onClick={() => handleItemClick(index)}
              // onDoubleClick={() => handleDoubleClick(index, item)}
              onClick={() => handleTabClickWrapper(index, item)}
              onDoubleClick={() => handleTabDoubleClickWrapper(index, item)}
              onKeyDown={(event) => handleTabKeyDownWrapper(event, index, item)}
              id={`item-tabbar-new-${index}`}
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "0 8px",
                pointerEvents: "auto",
              }}
            >
              {editingIndex === index && showAddRemove ? (
                <input
                  type="text"
                  className="form-control form-control-md"
                  value={newItemValue}
                  onChange={handleInputChange}
                  onBlur={() => handleInputBlur(index)}
                  autoFocus
                  style={{ flexGrow: 1 }}
                  data-testid="new-item"
                />
              ) : (
                item[itemName]
              )}
              {showAddRemove && (!componentType || (componentType === "PV" && items?.length && index === items?.length - 1)) && index !== 0 && (
                <SeIcon
                  aria-label={`remove-tab-item-${index}`}
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent triggering the click on the <a> tag
                    removeItem(tabName ? item : item[itemId]);
                  }}
                  style={{ cursor: "pointer", marginLeft: "8px" }}
                  color="primary"
                >
                  action_remove_flat
                </SeIcon>
              )}
            </a>
          ))}
        {itemName === "dayGroupName" ? (
          items.length === 1 ? (
            <SeIcon aria-label="add-day-group-item" onClick={addItem} style={{ cursor: "pointer" }}>
              action_add_flat
            </SeIcon>
          ) : null
        ) : (showAddRemove) && (
          <SeIcon aria-label="add-tab-item" onClick={addItem} style={{ cursor: "pointer" }}>
            action_add_flat
          </SeIcon>
        )}
      </nav>
    </SeTabbar>
  );
};

export default DynamicTabbar;
